import { AssessmentAndPlan } from "~/providers/components";

export const OngoingPatientAssessmentAndPlan = () => <AssessmentAndPlan />;
